import { createContext, useContext } from 'react'

export const MediaQueryContext = createContext(null)

export function useMediaQueryContext() {
  return useContext(MediaQueryContext)
}

export const DsgvoContext = createContext({
  hover: false,
  accepted: false,
  setAccepted: () => {},
  setHover: () => {},
})

export function useDsgvoContext() {
  return useContext(DsgvoContext)
}
